module.exports = __webpack_public_path__ + "img/scan.18c0a6f8.png";